export default [
  {
    path: '/real-estate-developments-settings/accessories',
    name: 'AccessoriesList',
    component: () => import('pages/real-estate-developments-settings/accessories/AccessoriesList.vue')
  },
  {
    path: '/real-estate-developments-settings/accessories/new',
    name: 'AccessoriesCreate',
    component: () => import('pages/real-estate-developments-settings/accessories/AccessoriesForm.vue')
  },
  {
    path: '/real-estate-developments-settings/accessories/:id/edit',
    name: 'AccessoriesEdit',
    component: () => import('pages/real-estate-developments-settings/accessories/AccessoriesForm.vue')
  },
  {
    path: '/real-estate-developments-settings/accessories/:id',
    name: 'AccessoriesSingle',
    component: () => import('pages/real-estate-developments-settings/accessories/AccessoriesSingle.vue')
  }
]
